/**
 * @member {string} id
 * @member {Boolean} fixed_count_days
 * @member {Number|null} days_after_end_of_year
 * @member {Number} max_count_days
 * @member {Number} max_days_before_start
 * @member {Number} min_count_days
 * @member {Number} min_days_before_start
 * @member {string} name
 * @member {string} organization_subject_id
 * @member {string} start_day_time
 * @member {Number} period_count
 * @member {string} time_type_id
 */
export default class TimeTypeDto {
  id
  fixed_count_days
  days_after_end_of_year
  max_count_days
  max_days_before_start
  min_count_days
  min_days_before_start
  name
  organization_subject_id
  start_day_time
  period_count
  time_type_id

  /**
   * @param {string} id
   * @param {Boolean} fixed_count_days
   * @param {Number|null} days_after_end_of_year
   * @param {Number} max_count_days
   * @param {Number} max_days_before_start
   * @param {Number} min_count_days
   * @param {Number} min_days_before_start
   * @param {string} name
   * @param {string} organization_subject_id
   * @param {string} start_day_time
   * @param {Number} period_count
   * @param {string} time_type_id
   */
  constructor({
    id,
    fixed_count_days,
    days_after_end_of_year,
    max_count_days,
    max_days_before_start,
    min_count_days,
    min_days_before_start,
    name,
    organization_subject_id,
    start_day_time,
    period_count,
    time_type_id
  }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: false
    }

    id = String(id)
    fixed_count_days = Boolean(fixed_count_days)
    if ([undefined, null].includes(days_after_end_of_year)) {
      days_after_end_of_year = null
    } else {
      days_after_end_of_year = Number(days_after_end_of_year)
    }
    max_count_days = max_count_days ? Number(max_count_days) : 0
    max_days_before_start = max_days_before_start ? Number(max_days_before_start) : 0
    min_count_days = min_count_days ? Number(min_count_days) : 0
    min_days_before_start = min_days_before_start ? Number(min_days_before_start) : 0
    name = String(name)
    organization_subject_id = String(organization_subject_id)
    start_day_time = String(start_day_time)
    period_count = period_count ? Number(period_count) : 0
    time_type_id = String(time_type_id)

    Object.defineProperty(this, 'id', Object.assign({ value: id }, properties))
    Object.defineProperty(this, 'fixed_count_days', Object.assign({ value: fixed_count_days }, properties))
    Object.defineProperty(this, 'days_after_end_of_year', Object.assign({ value: days_after_end_of_year }, properties))
    Object.defineProperty(this, 'max_count_days', Object.assign({ value: max_count_days }, properties))
    Object.defineProperty(this, 'max_days_before_start', Object.assign({ value: max_days_before_start }, properties))
    Object.defineProperty(this, 'min_count_days', Object.assign({ value: min_count_days }, properties))
    Object.defineProperty(this, 'min_days_before_start', Object.assign({ value: min_days_before_start }, properties))
    Object.defineProperty(this, 'name', Object.assign({ value: name }, properties))
    Object.defineProperty(this, 'organization_subject_id', Object.assign({ value: organization_subject_id }, properties))
    Object.defineProperty(this, 'start_day_time', Object.assign({ value: start_day_time }, properties))
    Object.defineProperty(this, 'period_count', Object.assign({ value: period_count }, properties))
    Object.defineProperty(this, 'time_type_id', Object.assign({ value: time_type_id }, properties))

    Object.freeze(this)
  }
}
